import Skeleton from "@mui/material/Skeleton";

const PortfolioSkeleton = () => {
  return (
    <>
      <div className="right_wrap pb-4">
        <div className="stake_top_box">
          <div className="stake_bx_grid">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="dashboard_box">
                <Skeleton
                  variant="rectangular"
                  style={{ width: "60px", height: "24px", borderRadius: "4px" }}
                  className="dsh_skl_card_lbl_cnt"
                />
                <div className="mt-3 d-flex flex-column align-items-center justify-content-center text-center">
                  <Skeleton
                    variant="text"
                    style={{ width: "160px" }}
                    className="dsh_skl_card_lbl_cnt"
                  />
                  <h4 className="my-2">
                    <Skeleton variant="text" className="dsh_skl_card_lbl_cnt" />
                  </h4>
                  <Skeleton
                    variant="text"
                    style={{ width: "160px" }}
                    className="dsh_skl_card_lbl_cnt"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PortfolioSkeleton;
